import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message } from "antd";
import { ReportCatalogItem } from "../../lib/interfaces/Report";
import { LoadingStatusCode } from "../../lib/types/LoadingStatusCode";
import LoadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { getReportRoute, getReportsCatalogRoute } from "../../lib/routes/reports";

interface InitialState {
  reportUrl?: string;
  reportUrlLoading: LoadingStatusCode;
  reportsCatalog: ReportCatalogItem[];
  reportsCatalogLoading: LoadingStatusCode;
}

const initialState: InitialState = {
  reportUrl: undefined,
  reportUrlLoading: LoadingStatusCodes.idle,
  reportsCatalog: [],
  reportsCatalogLoading: LoadingStatusCodes.idle,
};

const getReport = createAsyncThunk("reports/getReport", async (reportId: number) => {
  try {
    const response = axios.post<{ url: string }>(getReportRoute(reportId));
    const { data } = await response;
    return data;
  } catch (e) {
    message.destroy();
    message.error("Ошибка получения отчёта");
    return undefined;
  }
});

const getReportsCatalog = createAsyncThunk("reports/getReportsCatalog", async () => {
  try {
    const response = axios.get<ReportCatalogItem[]>(getReportsCatalogRoute());
    const { data } = await response;
    return data;
  } catch (e) {
    message.destroy();
    message.error("Ошибка получения каталога");
    return [];
  }
});

export const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    resetReportUrl: (state) => {
      state.reportUrl = undefined;
      state.reportUrlLoading = LoadingStatusCodes.idle;
      state.reportsCatalog = [];
      state.reportsCatalogLoading = LoadingStatusCodes.idle;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReport.pending, (state) => {
        state.reportUrlLoading = LoadingStatusCodes.pending;
      })
      .addCase(getReport.fulfilled, (state, action) => {
        state.reportUrlLoading = LoadingStatusCodes.fulfilled;
        state.reportUrl = action.payload?.url;
      })
      .addCase(getReport.rejected, (state) => {
        state.reportUrlLoading = LoadingStatusCodes.rejected;
      })
      .addCase(getReportsCatalog.pending, (state) => {
        state.reportsCatalogLoading = LoadingStatusCodes.pending;
      })
      .addCase(getReportsCatalog.fulfilled, (state, action) => {
        state.reportsCatalogLoading = LoadingStatusCodes.fulfilled;
        state.reportsCatalog = action.payload;
      })
      .addCase(getReportsCatalog.rejected, (state) => {
        state.reportsCatalogLoading = LoadingStatusCodes.rejected;
      });
  },
});

const { reducer } = reportsSlice;

const { resetReportUrl } = reportsSlice.actions;

export { reducer, getReport, getReportsCatalog, resetReportUrl };
